import {Attendee} from 'Event/attendee'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'

export type ZapierTag = {
  name: string
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/zapier/add_tag`)
  return (tag: ZapierTag) => {
    try {
      client.post(url, {name: tag})
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/zapier/test_tag`)
  return async (tag: ZapierTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      tag,
      attendee_id: attendee.id,
    })
  }
}
